import { Injectable } from '@angular/core';

declare var gtag: any;
declare var GA_TRACKING_ID: string;

export interface EventGst {
  event_category?: string;
  event_label?: string;
  value?: number | string;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  pageTrack(path: string): void {
    if (typeof gtag !== 'undefined' && gtag && GA_TRACKING_ID) {
      gtag('config', GA_TRACKING_ID, { page_path: path });
    }
  }

  eventTrack(action: string, properties: Partial<EventGst> = {}): void {
    if (typeof gtag !== 'undefined' && gtag && GA_TRACKING_ID) {
      gtag('event', action, properties);
    }
  }
}
